// Based on env variable exports appropriate getData method so it connects with real or mock API

const suffix = process.env.REACT_APP_RUN_MODE === "no-auth" ? ".mock" : "";

module.exports = require("./fetchData" + suffix).default;
